import * as taskTypes from "Store/backgroundTasks/constants";

export const backgroundTaskStarted = (payload: {
  id: string;
  label: string;
  classroomId: string;
  total: number;
  kind: taskTypes.BackgroundTaskKind;
}): taskTypes.IBackgroundTaskStarted => ({
  type: taskTypes.BACKGROUND_TASK_STARTED,
  payload
});

export const backgroundTaskProgress = (payload: {
  id: string;
  processed: number;
  failed: number;
  total: number;
}): taskTypes.IBackgroundTaskProgress => ({
  type: taskTypes.BACKGROUND_TASK_PROGRESS,
  payload
});

export const backgroundTaskFinished = (payload: {
  id: string;
  processed: number;
  failed: number;
  total: number;
}): taskTypes.IBackgroundTaskFinished => ({
  type: taskTypes.BACKGROUND_TASK_FINISHED,
  payload
});

export const backgroundTaskDismissed = (payload: {
  id: string;
}): taskTypes.IBackgroundTaskDismissed => ({
  type: taskTypes.BACKGROUND_TASK_DISMISSED,
  payload
});
